import React from 'react'

const HorizentalFlexBox = ({children, width = '100%', className}) => {
  let HFBClassName = 'column-flexbox' + (className ? ' ' + className : '')
  return (
    <div className={HFBClassName} style={{width}}>
      {children}
    </div>
  )
}

export default HorizentalFlexBox



// WEBPACK FOOTER //
// ../src/commons/components/SegmentsPopupContent/ColumnFlexBox.js